import { IStargateClient, StargateClient } from '@atlassiansox/asc-stargate';
import React, { createContext, PropsWithChildren, useContext } from 'react';

const DEFAULT_BASE_URL = 'https://wac.stg.internal.atlassian.com/gateway/api';

const StargateClientContext = createContext<IStargateClient>(
  new StargateClient({
    baseUrl: DEFAULT_BASE_URL
  })
);

export function useStargateClient(): IStargateClient {
  return useContext(StargateClientContext);
}

export type StargateClientProviderProps =
  | InterfaceStargateClientProviderProps
  | BaseUrlStargateClientProviderProps;

export type InterfaceStargateClientProviderProps = {
  readonly client: IStargateClient;
};

export type BaseUrlStargateClientProviderProps = {
  readonly baseUrl: string;
};

export function StargateClientProvider(
  props: PropsWithChildren<StargateClientProviderProps>
) {
  const { children } = props;
  if (isBaseUrlStargateClientProviderProps(props)) {
    return (
      <StargateClientContext.Provider
        value={
          new StargateClient({
            baseUrl: props.baseUrl
          })
        }
      >
        {children}
      </StargateClientContext.Provider>
    );
  } else {
    return (
      <StargateClientContext.Provider value={props.client}>
        {children}
      </StargateClientContext.Provider>
    );
  }
}

function isBaseUrlStargateClientProviderProps(
  props: StargateClientProviderProps
): props is BaseUrlStargateClientProviderProps {
  return !!(props as BaseUrlStargateClientProviderProps)?.baseUrl;
}
